module.exports = __webpack_public_path__ + "img/icon-riesgos-2.07f8cc23.png";